import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";

import { MfaQueryKeys } from "../query-keys";

const mfaSchema = z.object({
  settings: z.object({
    enabled: z.boolean().default(false),
    totp: z.boolean().default(false),
  }),
});

function useMfa() {
  const api = useApi();
  const { currentAccount } = useAuth();

  return useQuery({
    enabled: !!currentAccount,
    queryKey: MfaQueryKeys.settings(currentAccount?.id),
    queryFn: async () => {
      const { data } = await api.get("/api/pleroma/accounts/mfa");
      return mfaSchema.parse(data);
    },
  });
}

export { useMfa };
